var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loaderWrapper",style:({ background: _vm.color })},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"color":"#c1c1c1"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }